export const isPlannedDateExceeded = (plannedDate: string | number | Date): boolean => {
	return new Date(plannedDate).getTime() < new Date().getTime();
};
